import { useEffect, useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';

import Paper from '@mui/material/Paper';
import { Box } from '@mui/material';
import TablePagination from '@mui/material/TablePagination';

import formatDateTimeUK from '@/helpers/formatDateTimeUK';

import { getRequest } from '@/services/api';

const PhlebotomyRequests = ({ user }) => {
	const [phlebotomyRequestData, setPhlebotomyRequestData] = useState(null);

	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	useEffect(() => {
		const fetchPhlebotomyRequest = async () => {
			try {
				const fetchedTests = await getRequest(`/products/phlebotomy-requests/${user.customer_id}`);
				setPhlebotomyRequestData(fetchedTests.data);
			} catch (error) {
				console.error('Error fetching phlebotomy tests:', error);
			}
		};
		fetchPhlebotomyRequest();
	}, []);

	if (!phlebotomyRequestData) {
		return (
			<Box sx={{ width: '100%' }}>
				<h2>Phlebotomy Requests</h2>
				<p>No available phlebotomy Requests</p>
			</Box>
		);
	}

	return (
		<Box sx={{ width: '100%' }}>
			<h2>Phlebotomy Requests</h2>
			<Paper sx={{ width: '100%', mb: 2, p: 2 }}>
				{phlebotomyRequestData
					?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
					.map((request, index) => (
						<Accordion key={request.request_id || index}>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls={`panel-${index}-content`}
								id={`panel-${index}-header`}
							>
								<Typography variant="h6" sx={{ fontWeight: 500 }}>
									Request #{request.request_id}
								</Typography>

								<Typography component="span" sx={{ marginLeft: 2, color: 'text.secondary' }}>
									Customer id: {request.customer_id} - Phlebotomy type:{' '}
									{request.phlebotomy_type || 'Standard'} - Created at:{' '}
									{formatDateTimeUK(request.created_at)}
								</Typography>
							</AccordionSummary>

							<AccordionDetails>
								<div
									style={{
										display: 'grid',
										gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
										gap: '1rem',
									}}
								>
									<div>
										<strong>Number of Customers:</strong> {request.number_of_customers}
										<br />
										<strong>Tests Required:</strong> {request.tests_required}
										<br />
										<strong>Customer Consent:</strong> {request.customer_consent}
										<br />
										<strong>Facilities:</strong> {request.facilities}
										<br />
										<strong>Quantity of Facilities:</strong> {request.quantity_of_facilities}
										<br />
										<strong>Phlebotomy Type:</strong> {request.phlebotomy_type}
										<br />
										<strong>Phlebotomy Required:</strong> {request.phlebotomy_required}
										<br />
										<strong>Available Parking:</strong> {request.available_parking}
										<br />
										<strong>Parking Description:</strong> {request.parking_desc}
										<br />
									</div>

									<div>
										<strong>File Uploaded:</strong> {request.file_uploaded}
										<br />
										<strong>Sample Collection:</strong> {request.sample_collection}
										<br />
										<strong>Sample Bin Description:</strong> {request.sample_bin_desc}
										<br />
										<strong>Request Comments:</strong> {request.request_comments}
										<br />
										<strong>Special Requirements:</strong> {request.special_requirements}
										<br />
										<strong>Bin Arrangement:</strong> {request.bin_arrangement}
										<br />
										<strong>Testing Site Contact:</strong> {request.testing_site_contact}
										<br />
										<strong>Created At:</strong> {formatDateTimeUK(request.created_at)}
										<br />
										<strong>Customer Info Provision Date:</strong>{' '}
										{formatDateTimeUK(request.customer_info_provision_date)}
										<br />
									</div>
								</div>
							</AccordionDetails>
						</Accordion>
					))}
				<TablePagination
					rowsPerPageOptions={[5, 10, 25]}
					component="div"
					count={phlebotomyRequestData?.length || 0}
					rowsPerPage={rowsPerPage}
					page={page}
					onPageChange={handleChangePage}
					onRowsPerPageChange={handleChangeRowsPerPage}
				/>
			</Paper>
		</Box>
	);
};

export default PhlebotomyRequests;
